import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';

const ModalGirosGanhos = ({ giros, onClose }) => {
  const navigate = useNavigate();

  if (!giros || giros <= 0) return null;

  const irParaRoleta = () => {
    onClose();
    navigate('/roleta');
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeBtn} onClick={onClose} aria-label="Fechar">
          ×
        </button>

        <div className={styles.icon}>🎡</div>
        <h2 className={styles.titulo}>Parabéns!</h2>
        <p className={styles.texto}>
          Você ganhou{' '}
          <strong className={styles.destaque}>
            {giros} giro{giros !== 1 ? 's' : ''}
          </strong>{' '}
          na Roleta da Sorte!
        </p>
        <p className={styles.subtexto}>
          Gire agora e concorra a cotas, PIX e prêmios.
        </p>

        <button className={styles.btnRoleta} onClick={irParaRoleta}>
          🎰 Ir para a Roleta
        </button>
        <button className={styles.btnDepois} onClick={onClose}>
          Agora não
        </button>
      </div>
    </div>
  );
};

export default ModalGirosGanhos;
